<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 5A11 11 0 115 16 11 11 0 0116 5m0-2a13 13 0 1013 13A13 13 0 0016 3z"/><path d="M14.2 21.45l-5.7-5.27a1 1 0 111.35-1.47l4.28 4 8-8.09a1 1 0 011.42 0 1 1 0 010 1.41z"/></svg>